export const REQUEST_QUESTIONNAIRE_AVAILABILITY = 'REQUEST_QUESTIONNAIRE_AVAILABILITY';
export const REQUEST_QUESTIONNAIRE_AVAILABILITY_SUCCESS =
  'REQUEST_QUESTIONNAIRE_AVAILABILITY_SUCCESS';
export const REQUEST_QUESTIONNAIRE_AVAILABILITY_ERROR = 'REQUEST_QUESTIONNAIRE_AVAILABILITY_ERROR';

export const requestQuestionnaireAvailabilityAction = payload => ({
  type: REQUEST_QUESTIONNAIRE_AVAILABILITY,
  payload,
});
